import React from 'react'
import { observer, propTypes as mobxPropTypes } from 'mobx-react'
import PropTypes from 'prop-types'

import DownloadEplPdfLink from './DownloadEplPdfLink'
import InfoBox from '@components/InfoBox'

const ExpertApplicationInfo = ({ staticData, epl }) => {
  const { REPLY_STATUSES } = staticData.CONST
  if (epl.epl.replyStatusId !== REPLY_STATUSES.APPLIED) {
    return null
  }

  const expertSchedulingRequest = epl.epl && epl.epl.expertSchedulingRequest
  const screeningQuestions = epl.epl.screeningQuestions || []

  let content
  if (screeningQuestions.length || expertSchedulingRequest) {
    content = (
      <div>
        <ExpertScreeningAnswers screeningQuestions={screeningQuestions} />
        {expertSchedulingRequest && (
          <p className='m-t-lg'>
            <b>Notes:</b>
            <div
              dangerouslySetInnerHTML={{ __html: expertSchedulingRequest }}
            />
          </p>
        )}
      </div>
    )
  } else {
    content = <div>No screening answers or notes added.</div>
  }

  return (
    <div className='expert-form__section'>
      <h2 className='expert-form__subtitle'>Screening questions</h2>
      <DownloadEplPdfLink epl={epl} />

      <InfoBox>{content}</InfoBox>
    </div>
  )
}

ExpertApplicationInfo.propTypes = {
  epl: PropTypes.object,
  staticData: PropTypes.object
}

const ExpertScreeningAnswers = ({ screeningQuestions }) => {
  if (screeningQuestions.length === 0) return null

  const questionsAndAnswers = screeningQuestions.map(screeningQA => {
    return (
      <div className='edit-epl__screening-qa' key={screeningQA.id}>
        <b>
          <div
            className='edit-epl__screening-qa-item'
            dangerouslySetInnerHTML={{ __html: screeningQA.question }}
          />
        </b>
        <div
          className='edit-epl__screening-qa-item'
          dangerouslySetInnerHTML={{ __html: screeningQA.answer }}
        />
      </div>
    )
  })

  return <div>{questionsAndAnswers}</div>
}

ExpertScreeningAnswers.propTypes = {
  screeningQuestions: mobxPropTypes.observableArray
}

export default observer(ExpertApplicationInfo)
